import addFaq from './add';
import faqList from './list';

const translations = {
  ...addFaq,
  ...faqList,
};

export default translations;
